// Relay set shared with pallasite / neon-sentinel / hang-on-fren.
// gamestr-arcade reads kinds 30762/5555 from these.

export const WRITE_RELAYS = [
  'wss://main.relay.gamestr.io',
  'wss://relay.trotters.cc',
  'wss://nos.lol',
  'wss://relay.damus.io',
  'wss://relay.nostr.band',
  'wss://relay.primal.net',
  'wss://relay.ditto.pub',
];

export const READ_RELAYS = [
  'wss://main.relay.gamestr.io',
  'wss://relay.trotters.cc',
  'wss://relay.damus.io',
  'wss://relay.nostr.band',
];

export const PROFILE_RELAYS = [
  'wss://purplepag.es',
  'wss://relay.damus.io',
  'wss://relay.primal.net',
];
